export class FinancialStatusUpdate {
    date: Date | null;
    financialStatusID: number;
    profileID: number;
    sendUpdateTo2CP: boolean | null;
    modUser = '';
    candidateStatusID: number | null;
}